import React, {Component} from 'react';
import Card from '../../common/card-grid/Card';
import {
  Button,
  Wrapper,
  Container,
  List,
  Row,
  Item,
  Input,
  selectAll,
  selectNone,
  select,
  isSelected,
  getFilteredData,
} from '../../settings/Select';
import {FILTER_NONE, FILTER_ALL} from '../../../constants/filters';
import gql from 'graphql-tag';
import {Query, withApollo} from 'react-apollo';
import INTERRUPTING_DISFUNCTIONS from '../../../constants/interruptingDisfunctions';
import Loading from '../Loading';
import Error from '../Error';

const interruptingDisfunctionsSettingsQuery = gql`
  query interruptingDisfunctionsSettings($input: SettingsQueryInput!) {
    disfunctions: disfunctionTypes(input: {filter: {isInterrupting: true}}) {
      id
      name
      isInterrupting
    }
    settings(input: $input) {
      id
      interruptingDisfunctions {
        type
        ids
      }
    }
  }
`;

class InterruptingDisfunctions extends Component {
  state = {
    search: '',
  };

  render() {
    const input = {favoriteId: this.props.favoriteId};
    return (
      <Query query={interruptingDisfunctionsSettingsQuery} variables={{input}}>
        {({loading, error, data}) => {
          if (loading)
            return (
              <Card>
                <Loading />
              </Card>
            );
          if (error) return <Error>{error.message}</Error>;
          let filterInterruptingDisfunctions = getFilteredData(data.disfunctions, this.state.search);
          return (
            <Card>
              <Wrapper>
                <Button
                  active={data.settings.interruptingDisfunctions.type === FILTER_ALL}
                  onClick={() => selectAll(this, data.disfunctions, 'id', 'interruptingDisfunctions')}>
                  {INTERRUPTING_DISFUNCTIONS.find((t) => t.key === FILTER_ALL).label}
                </Button>
                <Button
                  active={data.settings.interruptingDisfunctions.type === FILTER_NONE}
                  onClick={() => selectNone(this, data.disfunctions, 'id', 'interruptingDisfunctions')}>
                  {INTERRUPTING_DISFUNCTIONS.find((t) => t.key === FILTER_NONE).label}
                </Button>
              </Wrapper>
              <Input
                placeholder={'Search interruptingDisfunctions'}
                value={this.state.interruptingDisfunctions}
                onChange={(e) => this.setState({search: e.target.value})}
              />
              <Container>
                <List
                  itemCount={filterInterruptingDisfunctions.length}
                  renderItem={({index, style}) => (
                    <Row
                      style={style}
                      key={index}
                      onClick={() =>
                        select(
                          this,
                          data.settings.interruptingDisfunctions,
                          filterInterruptingDisfunctions[index].id,
                          data.disfunctions,
                          'id',
                          'interruptingDisfunctions'
                        )
                      }
                      selected={isSelected(
                        data.settings.interruptingDisfunctions,
                        filterInterruptingDisfunctions[index].id
                      )}>
                      <Item>{filterInterruptingDisfunctions[index].name}</Item>
                    </Row>
                  )}
                />
              </Container>
            </Card>
          );
        }}
      </Query>
    );
  }
}

export default withApollo(InterruptingDisfunctions);
